import { useState, useCallback, useEffect } from "react"
import useEffectAsync from "../../hooks/useEffectAsync";
import fetcher from "../../utils/fetcher";
import ModalError from "../Modal/ModalError";
import ModalLoading from "../Modal/ModalLoading";
import { useGetPlotQuery } from "/src/redux/plotsApi";
import { redMarkerIcon, whiteMarkerIcon } from "/src/utils/leafletIconsCustom";

export default function MapItem({ map, _id, lat, lng, open, onSave, onOpen, onClose }) {

    const [innerEl, setInnerEl] = useState(null);
    const getInnerEl = useCallback(node=>setInnerEl(node), []);
    const [marker, setMarker] = useState(null);
    const [error, setError] = useState(null);
    const { data: details, error: queryError, isLoading } = useGetPlotQuery(_id, {skip: !open || !_id});

    // copy query error to state
    useEffect(()=>{
        setError(queryError && queryError.data);
    },[queryError]);

    const goToMarker = useCallback(()=>{
        if(map && marker){
            const latlng = marker.getLatLng();
            map.flyTo(latlng, map._layersMaxZoom - 1);
        }
    },[map, marker]);

    const onPopupOpen = useCallback((e)=>{
        // console.debug('popup open', e);
        if(onOpen) onOpen(e);
    },[onOpen, open]);
    const onPopupClose = useCallback((e)=>{
        // console.debug('popup close', e);
        if(onClose) onClose(e);
    },[onOpen, open]);

    // handle marker itself
    useEffect(()=>{
        let lastMarker;
        if(map && !marker){
            // const newMarker = L.circle([0,0], {
            //     color: 'white',
            //     fillColor: 'whitesmoke',
            //     fillOpacity: 0.5,
            //     radius: 1,
            // }).addTo(map);
            const newMarker = L.marker([0,0], {
                icon: _id?redMarkerIcon:whiteMarkerIcon,
            }).addTo(map);
            // console.warn('marker new to map');
            setMarker(newMarker);
            lastMarker = newMarker;
        }else if(map && marker){
            // console.warn('marker add to map');
            marker.addTo(map);
            lastMarker = marker;
        }
        return ()=>{
            // console.debug('marker remove from map', !!map, !!lastMarker);
            if(map && lastMarker){
                map.removeLayer(lastMarker);
            }
        }
    }, [map, marker]);

    // handle marker position
    useEffect(()=>{
        if(marker && lat && lng){
            marker.setLatLng([lat, lng]);
            if(open){
                marker.openPopup();
                goToMarker();
            }
        }
    }, [marker, lng, lat, open]);

    // handle popup el
    useEffect(()=>{
        if(marker){
            if(innerEl){
                marker.bindPopup(innerEl);
                marker.on('popupopen', onPopupOpen);
                marker.on('popupclose', onPopupClose);
            }else{
                marker.unbindPopup();
                marker.off('popupopen', onPopupOpen);
                marker.off('popupclose', onPopupClose);
            }
        }
        return ()=>{
            if(marker){
                marker.unbindPopup();
                marker.off('popupopen', onPopupOpen);
                marker.off('popupclose', onPopupClose);
            }
        }
    }, [marker, innerEl]);

    // handle open state
    useEffect(()=>{
        if(marker && innerEl){
            if(open && innerEl){
                marker.openPopup();
                goToMarker();
            }else{
                marker.closePopup();
            }
        }
    }, [marker, innerEl, open]);

    return (
        <div className="hidden">
            <div ref={getInnerEl} className='relative'>
                {isLoading && <ModalLoading absolute={true} />}
                {error && <ModalError title="Error" message={error.message} description={error.status || error.code} callback={()=>setError(null)} />}
                <div className="w-60">
                    <div className='border-b mb-4'>
                        <h3 className='text-2xl font-light m-4'>{_id?'Plot Information':'New Plot'}</h3>
                    </div>
                    <table className="overflow-x-hidden overflow-y-auto m-3 max-h-72">
                        <thead>
                            {details && 
                                <tr>
                                    <th className="pr-4">Section</th>
                                    <th className="pr-4">Lot</th>
                                </tr>
                            }
                        </thead>
                        <tbody>
                            {(details && 
                                <tr className='text-ellipsis break-words font-mono text-2xl'>
                                    <td>
                                        <span className="font-bold">{details.section}</span>
                                    </td>
                                    <td>{details.lot}{details.lotPart}</td>
                                </tr>
                            ) || (
                                <tr>
                                    <td colSpan={2}>No Entry</td>
                                </tr>
                            )}
                            {/* <tr className='text-ellipsis break-words font-mono text-yellow-400'>
                                <td colSpan={2} >
                                    <span>{_id || 'N/A'}</span>
                                </td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}